import { myGalleryMediaFilesSource, useTranslation } from "@next-platform/client-common-core";
import { useEventCapabilityIsUsed } from "@next-platform/client-common-core/services/databricks";
import { SubCapabilityKey } from "@next-platform/packages-ts-types";
import { useEffect } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import useGuestSignIn from "@/hooks/useGuestSignIn";
import useIsLoggedOutReader from "@/hooks/useIsLoggedOutReader";
import Gallery from "@/pages/Gallery/components/Gallery";

const MyGallery = () => {
  // `t` subscribes the page to language changes; a bare `<Trans>` only re-renders with its parent.
  const { t } = useTranslation();
  const raiseEventCapabilityIsUsed = useEventCapabilityIsUsed();
  // A logged out reader gets no grid, only the sign in overlay.
  const isLoggedOutReader = useIsLoggedOutReader();
  useGuestSignIn({ isEnabled: isLoggedOutReader });
  // One usage per page open: the grid paging below never remounts the page, leaving and returning does.
  useEffect(() => {
    if (!isLoggedOutReader) {
      raiseEventCapabilityIsUsed(SubCapabilityKey.GalleryMyGallery);
    }
  }, [isLoggedOutReader, raiseEventCapabilityIsUsed]);

  return (
    <div data-testid="MyGallery">
      <PageStaticMetaTags pageId="myGallery" data-testid="MyGallery-PageMetaTags" />
      {isLoggedOutReader ? null : <Gallery title={t("appMenu:myGallery")} source={myGalleryMediaFilesSource} />}
    </div>
  );
};

export default MyGallery;
